import { render } from "./FormMapItem.vue?vue&type=template&id=b50c940c"
import script from "./FormMapItem.vue?vue&type=script&lang=js"
export * from "./FormMapItem.vue?vue&type=script&lang=js"

import "./FormMapItem.vue?vue&type=style&index=0&id=b50c940c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__